export default [
  {
    header: 'Rules & deadlines',
    items: [
      {
        to: '/absentee-mail-ballot-deadlines/',
        text: 'Absentee ballot deadlines',
      },
      {
        to: '/absentee-mail-ballot-rules/',
        text: 'Absentee ballot rules',
      },
      {
        to: '/ballot-curing/',
        text: 'Ballot curing',
      },
      {
        to: '/ballot-request-methods/',
        text: 'Ballot request methods',
      },
      {
        to: '/ballot-return-methods/',
        text: 'Ballot return methods',
      },
      {
        to: '/early-voting/',
        text: 'Early voting dates',
      },
      {
        to: '/election-deadlines/',
        text: 'Election deadlines',
      },
      {
        to: '/emergency-absentee-ballots/',
        text: 'Emergency absentee ballot rules',
      },
      {
        to: '/military-and-overseas-voters/',
        text: 'Military and overseas voters',
      },
      {
        to: '/online-voter-registration/',
        text: 'Online voter registration',
      },
      {
        to: '/permanent-absentee-voting/',
        text: 'Permanent absentee voting',
      },
      {
        to: '/same-day-registration/',
        text: 'Same day registration',
      },
      {
        to: '/students/',
        text: 'Student voters',
      },
      {
        to: '/voter-id-laws/',
        text: 'Voter ID laws',
      },
      {
        to: '/pre-registration/',
        text: 'Voter pre-registration rules',
      },
      {
        to: '/voter-registration-deadlines/',
        text: 'Voter registration deadlines',
      },
      {
        to: '/voter-registration-laws/',
        text: 'Voter registration laws',
      },
      {
        to: '/voter-registration-methods/',
        text: 'Voter registration methods',
      },
      {
        to: '/voting-rights-restoration/',
        text: 'Voting rights restoration',
      },
      {
        to: '/ways-to-vote',
        text: 'Ways to vote',
      },
    ],
  },
  {
    header: 'Tools',
    items: [
      {
        to: '/am-i-registered-to-vote/',
        text: 'Check your registration status',
      },
      {
        to: '/local-election-offices/',
        text: 'Contact your election office',
      },
      {
        to: '/where-to-vote/',
        text: 'Find out where to vote',
      },
      {
        to: '/upcoming-elections/',
        text: 'Find upcoming elections',
      },
      {
        to: '/pledge-to-vote/',
        text: 'Pledge to vote',
      },
      {
        to: '/futurevoter/',
        text: 'FutureVoter - Pre-register to vote',
      },
      {
        to: '/register-to-vote/',
        text: 'Register to vote',
      },
      {
        to: '/absentee-mail-ballot/',
        text: 'Request your absentee ballot',
      },
      {
        to: '/absentee-mail-ballot/',
        text: 'Request your mail-in ballot',
      },
      {
        to: '/election-reminders/',
        text: 'Sign up for election reminders',
      },
      {
        to: '/pav/',
        text: 'Sign up for permanent absentee voting',
      },
      {
        to: '/ballot-tracker/',
        text: 'Track your absentee or mail ballot',
      },
      {
        to: '/provisional-ballot-tracker/',
        text: 'Track your provisional ballot',
      },
    ],
  },
  {
    header: 'Technology',
    items: [
      {
        to: '/civic-data-api/',
        text: 'Civic data API',
      },
      {
        to: 'https://docs.voteamerica.org/',
        text: 'Developer documentation',
      },
      {
        to: 'https://secure.voteamerica.org/free-software/',
        text: 'Free software',
      },
      {
        to: 'https://github.com/vote',
        text: 'GitHub',
      },
      {
        to: 'https://app.vanta.com/voteamerica/trust/63p5j27szqdeb70neoppiy',
        text: 'Security trust report',
      },

      {
        to: 'https://status.voteamerica.org/',
        text: 'Status',
      },
      {
        to: 'https://voteamericaplus.org/',
        text: 'VoteAmerica+',
      },
    ],
  },
  {
    header: 'Support our work',
    items: [
      {
        to: 'https://about.voteamerica.org/democracy-fund',
        text: 'The Democracy Fund',
      },
      {
        to: 'https://bitpay.com/732282/donate',
        text: 'Donate crypto',
      },
      {
        to: 'https://secure.actblue.com/donate/voteamerica-website?refcode=www.voteamerica.org',
        text: 'Donate online',
      },
      {
        to: 'https://stockdonator.com/stock-information/?oid=ccf876fe',
        text: 'Donate stock',
      },
      {
        to: 'https://www.paypal.com/donate/?hosted_button_id=N38T2TEUW37EN',
        text: 'Donate via Paypal',
      },
      {
        to: 'https://doublethedonation.com/voteamerica',
        text: 'Employer matching gifts',
      },
      {
        to: 'https://about.voteamerica.org/planned-giving',
        text: 'Planned giving',
      },

      {
        to: 'https://shop.voteamerica.org/',
        text: 'VoteAmerica merchandise',
      },
      {
        to: 'https://about.voteamerica.org/ways-to-give',
        text: 'Ways to give',
      },
    ],
  },
  {
    header: 'Organization',
    items: [
      {
        to: 'https://about.voteamerica.org',
        text: 'About',
      },
      {
        to: 'https://about.voteamerica.org/brand',
        text: 'Brand',
      },
      {
        to: 'https://voteamerica.breezy.hr',
        text: 'Careers',
      },
      {
        to: 'https://about.voteamerica.org/contact',
        text: 'Contact',
      },
      {
        to: 'https://about.voteamerica.org/financials',
        text: 'Financials',
      },
      {
        to: 'https://kb.voteamerica.org/',
        text: 'Knowledge base',
      },
      {
        to: 'https://shop.voteamerica.org/',
        text: 'Merchandise',
      },
      {
        to: 'https://about.voteamerica.org/privacy',
        text: 'Privacy policy',
      },
      {
        to: '/report-an-error/',
        text: 'Report an error',
      },
      {
        to: 'https://research.voteamerica.org/',
        text: 'Research',
      },
      {
        to: 'https://about.voteamerica.org/supporters',
        text: 'Supporters',
      },
      {
        to: 'https://about.voteamerica.org/team',
        text: 'Team',
      },
      {
        to: 'https://about.voteamerica.org/terms',
        text: 'Terms',
      },
      {
        to: 'https://about.voteamerica.org/values',
        text: 'Values',
      },
    ],
  },
];
